<md-dialog>
	<div md-dialog-header>
		<md-icon [icon]="icon()"></md-icon>
		<span class="md-text-lg-semibold"> {{ title() }}</span>
	</div>
	<div class="dialog-content">
		<div class="md-text-sm-regular">{{ body() }}</div>

		@if (errorMessage()) {
			<div class="error-message">
				<md-icon icon="untitled-ui/alerts/alert-triangle"></md-icon>
				<span>{{ errorMessage() }}</span>
			</div>
		}
	</div>

	<div md-dialog-footer>
		<button md-button (click)="close(false)" [disabled]="isLoading()">Cancel</button>
		<button md-button-brand (click)="confirm()" [disabled]="isLoading()">
			@if (isLoading()) {
				<lb-loader size="small"></lb-loader>
			} @else {
				{{ successText() }}
			}
		</button>
	</div>
</md-dialog>
